import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, getFormValues, reset } from 'redux-form';
import { connect } from 'react-redux';
import {
  MotifButton,
  MotifLabel,
  MotifTooltip,
  MotifErrorMessage,
} from '@ey-xd/motif-react';
import { useSelector } from 'react-redux';
import { addAttribute } from '../../common/Attribute';
import * as formHelpers from '../../scripts/formHelpers';
import { normalizeReportPeriodObjects } from '../../common/ReportPeriodUtils';

const QUARTER_SELECTION_WIDTH = 150;

const NewPeriodHeader = ({
  bulkRollForwardFormValues,
  enableSubmit,
  handleSubmit,
  isAudit,
  clientId,
}) => {
  useEffect(() => {
    //Add Attribute(type=button) to all button elements having attribute(role = 'combobox')
    addAttribute("button[role = 'combobox']", 'type', 'button');
  });

  const quarterOptionValues = ['Q1', 'Q2', 'Q3', 'Q4'];
  const featureFlags = useSelector((state) => state.featureManagementData);

  const currentYear = new Date().getFullYear();
  let yearOptionValues = [];
  const dropdownStartYear = isAudit == true ? currentYear - 1 : currentYear - 5;
  let initialYear =
    featureFlags && featureFlags['RestrictedReportPeriodLimit']
      ? dropdownStartYear
      : currentYear - 5;

  for (let i = initialYear; i <= currentYear + 10; i++) {
    yearOptionValues.push(i.toString());
  }

  // Combine yearOptions with quarterOptionValues
  const combinedOptions = [];
  yearOptionValues.forEach((year) => {
    quarterOptionValues.forEach((quarter) => {
      combinedOptions.push({
        key: `${quarter} ${year}`,
        text: `${quarter} ${year}`,
        value: `${quarter} ${year}`,
      });
    });
  });

  // Normalize and sort report period objects by 'text' column,
  // using ascending order for both year and quarter
  const reportPeriodOptions = normalizeReportPeriodObjects(
    combinedOptions,
    'text',
    'asc',
    'asc'
  );

  return (
    <>
      {/* Header area */}
      <div style={{ minHeight: '24px' }}></div>
      {/* Form area */}
      <form onSubmit={handleSubmit}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <MotifLabel className="mt-auto mb-auto mr-3">
            <strong>Create:</strong>
          </MotifLabel>
          <div className="mt-auto mr-3">
            <Field
              name="rollForwardToSelectionType"
              component={formHelpers.renderField}
              type="radio"
              value="nextAvailablePeriod"
              label="Next Available Report Period"
              dataTestId="rbNextAvailableReportPeriod"
            />
          </div>
          <div className="mt-auto mr-3">
            <Field
              name="rollForwardToSelectionType"
              component={formHelpers.renderField}
              type="radio"
              value="customPeriod"
              label="Select Report Period"
              dataTestId="rbSelectReportPeriod"
            />
          </div>
          <div className="mr-3">
            <div style={{ width: QUARTER_SELECTION_WIDTH }}>
              <Field
                name="quarterSelection"
                label="To"
                options={reportPeriodOptions}
                component={formHelpers.SingleSelectComponent}
                disabled={
                  bulkRollForwardFormValues?.rollForwardToSelectionType !==
                  'customPeriod'
                }
                testingData={{ label: 'lblTo', div: 'divTo' }}
              />
            </div>
          </div>
          <div className="mb-auto" style={{ flex: '2' }}>
            <MotifButton
              data-testid="btnCreateNewPeriod"
              className="ml-auto"
              disabled={!enableSubmit}
            >
              <span>Create New Period</span>
            </MotifButton>
          </div>
        </div>
      </form>
    </>
  );
};

NewPeriodHeader.propTypes = {
  enableSubmit: PropTypes.bool,
  handleSubmit: PropTypes.func,
  clientId: PropTypes.number,
};

export default connect((state) => ({
  bulkRollForwardFormValues: getFormValues('bulkRollForwardForm')(state),
}))(reduxForm({ form: 'bulkRollForwardForm' })(NewPeriodHeader));
